<template>
    <div class="transfer-button-content">
        <el-button v-if="roundFlag" :size="size" round @click="transferFile">
            移动到
        </el-button>
        <el-button v-if="circleFlag" icon="el-icon-position" :size="size" circle @click="transferFile">
        </el-button>
        <el-dialog title="移动文件" :visible.sync="treeDialogVisible" @open="loadTreeData" @closed="resetTreeData"
            width="30%" :append-to-body=true :modal-append-to-body=false :center=true>
            <el-input v-model.trim="searchFileName" placeholder="请输入文件名搜索" clearable class="search-input" />
            <div class="tree-content">
                <el-tree class="tree" :data="filterTreeData" empty-text="暂无文件夹数据" default-expand-all highlight-current
                    check-on-click-node :expand-on-click-node="false" ref="tree">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <i class="fa fa-folder-o" style="margin-right: 15px; font-size: 20px; cursor: pointer;" />
                        <span>{{ data.fileName }}</span>
                    </span>
                </el-tree>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="treeDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="doChoseTreeNodeCallBack" :loading="loading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

import fileService from '../../../api/file'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'TransferButton',
    components: {},
    props: {
        roundFlag: Boolean,
        circleFlag: Boolean,
        size: String,
        item: Object
    },
    data() {
        return {
            treeDialogVisible: false,
            treeData: [],
            originTreeData: [],
            searchFileName: '',
            loading: false
        }
    },
    methods: {
        ...mapActions({
            reloadFileList: 'file/loadFileList'
        }),
        transferFile() {
            let _this = this
            if (!_this.item && (!_this.multipleSelection || _this.multipleSelection.length == 0)) {
                _this.$message.error('请选择要移动的文件')
                return
            }
            _this.treeDialogVisible = true
        },
        doTransferFile(targetParentId) {
            let _this = this
            var fileIdArr = []
            if (_this.item) {
                fileIdArr = [_this.item.flowNo]
            } else {
                _this.multipleSelection.forEach(item => fileIdArr.push(item.flowNo))
            }
            fileService.transfer({
                flowNos: fileIdArr,
                parentFlowNo: targetParentId
            }, res => {
                _this.loading = false
                _this.treeDialogVisible = false
                _this.$message.success('文件移动成功')
                _this.reloadFileList()
            }, res => {
                _this.loading = false
                _this.$message.error(res.message)
            })
        },
        doChoseTreeNodeCallBack() {
            let checkNode = this.$refs.tree.getCurrentNode()
            if (!checkNode) {
                this.$message.error('请选择文件夹')
                return
            }
            this.$confirm(`是否确认移动到${checkNode.fileName}中`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true
                this.doTransferFile(checkNode.flowNo)
            }).catch(() => {
            })
        },
        resetTreeData() {
            this.treeData = new Array()
            this.originTreeData = new Array()
            this.searchFileName = ''
        },
        loadTreeData() {
            let _this = this
            fileService.getFolderTree(res => {
                _this.treeData = [{
                    fileName: "根目录",
                    flowNo: -1,
                    children: res.data
                }]
                _this.originTreeData = _this.treeData
            }, res => {
                _this.$message.error(res.message)
            })
        },
        doFilterTreeData(treeData, searchFileName) {
            if (!searchFileName) {
                return treeData
            }
            return treeData.reduce((result, node) => {
                const children = node.children || []
                const filterChildren = this.doFilterTreeData(children, searchFileName)
                const currentMatch = node.fileName && node.fileName.indexOf(searchFileName) !== -1
                if (currentMatch || filterChildren.length > 0) {
                    result.push({
                        ...node,
                        children: filterChildren
                    })
                }
                return result
            }, [])
        },
    },
    computed: {
        ...mapGetters(['multipleSelection']),
        filterTreeData() {
            return this.doFilterTreeData(this.originTreeData, this.searchFileName)
        }
    },
    mounted() {
    },
    watch: {}
}
</script>

<style>
.transfer-button-content {
    display: inline-block;
    margin-right: 10px;
}

.tree-content {
    height: 400px;
    margin-top: 10px;
}

.tree-content .tree {
    height: 100%;
    overflow: auto;
}

.search-input {
    margin-bottom: 10px;
}
</style>